import { useRef as n, useEffect as s } from "react";
const i = (u, o, t = !1) => {
  const e = n(null), r = () => {
    e.current && (clearTimeout(e.current), e.current = null);
  };
  return s(() => t ? r : void 0, [t]), (...c) => {
    r(), e.current = setTimeout(() => u(...c), o);
  };
};
export {
  i as default
};
